import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { style } from '../../../api';
import { Input } from '../../common/Inputs';
import Loader from '../../common/Loader';
import { Text, Red } from '../../common/Text';
import AddTrack from '../../../containers/Modals/AddTrack';

export interface StateProps {
  playlists: {
    id: number;
    name: string;
  }[];
  isSubmitting: boolean;
  errorMessage?: string;
  hasFetchedPlaylists: false | number[];
  currentPage: number;
  lastPageReached: boolean;
}

export interface DispatchProps {
  fetchPlaylists: (page?: number, trackId?: number) => void;
  addTracktoPlaylist: (playlistId: number, trackId: number) => void;
  createPlaylist: (name: string) => void;
}

export interface OwnProps {
  id?: number;
}

type Props = StateProps & DispatchProps & OwnProps;

const Index = ({
  id,
  playlists,
  isSubmitting,
  errorMessage,
  fetchPlaylists,
  createPlaylist,
  hasFetchedPlaylists,
  lastPageReached,
  currentPage,
}: Props) => {
  useEffect(() => {
    fetchPlaylists(1, id);
  }, [fetchPlaylists, id]);

  const [submited, setSubmited] = useState(false);

  const { t } = useTranslation('modals');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    createPlaylist(e.target.playlist.value);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    e.target.playlist.value = '';
    setSubmited(true);
  };

  const removeError = () => {
    if (submited) setSubmited(false);
  };

  const loadMore = () => {
    if (!lastPageReached) {
      fetchPlaylists(currentPage + 1, id);
    }
  };

  const showLoadBtn = hasFetchedPlaylists && !lastPageReached;

  return (
    <FlexCol>
      <Row>
        <Title>{t('modals:myPlaylist') as string}</Title>
      </Row>
      <Container onSubmit={handleSubmit}>
        <Row>
          <Row>
            <Input name="playlist" onFocus={removeError} />
          </Row>
          <button type="button" disabled={isSubmitting}>
            {t('modals:create') as string}
          </button>
        </Row>
        {errorMessage && submited && (
          <Row>
            <Text>
              <Red>{errorMessage}</Red>
            </Text>
          </Row>
        )}
      </Container>

      <List>
        {playlists.map((playlist) => (
          <Row key={playlist.id}>
            <Name>
              {playlist.name.length > 15
                ? `${playlist.name.slice(0, 15)}...`
                : playlist.name}
            </Name>
            {id && (
              <AddTrack trackId={id} playlistId={playlist.id} added={false} />
            )}
          </Row>
        ))}
        {!hasFetchedPlaylists && <CenterLoader />}
      </List>
      {showLoadBtn && (
        <BtnContainer>
          <button type="button" onClick={loadMore}>
            {t('modals:loadMore') as string}
          </button>
        </BtnContainer>
      )}
    </FlexCol>
  );
};

export default Index;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CenterLoader = () => (
  <LoaderContainer>
    <Loader />
  </LoaderContainer>
);

const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  & button {
    margin-left: 10px;
  }

  ${Text} {
    padding-left: 20px;
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 10px;
  justify-content: space-between;
`;

const Title = styled.h4`
  margin: 0 0 0 -10px;
  padding: 0;
  font-size: 27px;
  font-weight: 700;
  color: ${style.black};
`;

const Name = styled.h5`
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 400;
  padding: 0;
  margin: 0;
`;

const List = styled.div`
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px;
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;

const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
